export const getModuleMessages = async (locale: string) => import(
    /* webpackChunkName: "orders-module-locale-[request]" */ `@/modules/reports/locales/${locale}.json`
);

export default getModuleMessages;
